module.exports = __webpack_public_path__ + "img/content3.e57fb2c9.png";